// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (min-width: 992px) {
    .general-shared-section {
        padding-top: 88px !important;
        padding-bottom: 88px !important;
    }
}



@media(min-width: 768px) and (max-width: 991px) {
    .general-shared-section {
        padding-top: 56px !important;
        padding-bottom: 56px !important;
        padding-left: 64px !important;

    }

    html[dir='rtl'] .general-shared-section {
        padding-right: 64px;
        padding-left: unset;
    }

    .general-shared-section h2,
    .general-shared-section p {
        text-align: justify !important;
    }

    /* .general-shared-section h2{ */

}

@media(max-width:767px) {
    .ksurgery-shared-section {
        padding-top: 32px !important;
        padding-bottom: 48px !important;
        padding-left: 32px !important;
        padding-right: 32px !important;
    }
}`, "",{"version":3,"sources":["webpack://./src/layout/components/SharedSection.css"],"names":[],"mappings":"AAAA;IACI;QACI,4BAA4B;QAC5B,+BAA+B;IACnC;AACJ;;;;AAIA;IACI;QACI,4BAA4B;QAC5B,+BAA+B;QAC/B,6BAA6B;;IAEjC;;IAEA;QACI,mBAAmB;QACnB,mBAAmB;IACvB;;IAEA;;QAEI,8BAA8B;IAClC;;IAEA,gCAAgC;;AAEpC;;AAEA;IACI;QACI,4BAA4B;QAC5B,+BAA+B;QAC/B,6BAA6B;QAC7B,8BAA8B;IAClC;AACJ","sourcesContent":["@media (min-width: 992px) {\n    .general-shared-section {\n        padding-top: 88px !important;\n        padding-bottom: 88px !important;\n    }\n}\n\n\n\n@media(min-width: 768px) and (max-width: 991px) {\n    .general-shared-section {\n        padding-top: 56px !important;\n        padding-bottom: 56px !important;\n        padding-left: 64px !important;\n\n    }\n\n    html[dir='rtl'] .general-shared-section {\n        padding-right: 64px;\n        padding-left: unset;\n    }\n\n    .general-shared-section h2,\n    .general-shared-section p {\n        text-align: justify !important;\n    }\n\n    /* .general-shared-section h2{ */\n\n}\n\n@media(max-width:767px) {\n    .ksurgery-shared-section {\n        padding-top: 32px !important;\n        padding-bottom: 48px !important;\n        padding-left: 32px !important;\n        padding-right: 32px !important;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
